import { getPersonShowPath } from "@/app/routing";
import type { Contact } from "@/components/atomic-crm/types";
import { isLeadLifecycleStatus } from "@/modules/constants/contactStatus";
import { normalizeLeadStage } from "@/modules/leads/leadStages";

/** @deprecated Prefer buildAccountsPersonPreviewParams */
export const buildAccountsLeadPreviewParams = (
  current: URLSearchParams,
  contactId: string | number,
  stage: string,
): URLSearchParams => {
  const next = new URLSearchParams(current);
  next.set("lead", String(contactId));
  next.set("contact", String(contactId));
  next.set("stage", stage);
  return next;
};

/** Open person preview on the current Accounts hub URL (keeps list/board view). */
export const buildAccountsPersonPreviewParams = (
  current: URLSearchParams,
  contact: Pick<Contact, "id" | "status" | "lead_stage">,
): URLSearchParams => {
  const next = new URLSearchParams(current);
  const id = String(contact.id);
  next.delete("company");
  next.set("contact", id);
  if (isLeadLifecycleStatus(contact.status)) {
    next.set("lead", id);
    next.set("stage", normalizeLeadStage(contact.lead_stage));
  } else {
    next.delete("lead");
    // Stage still required by LeadDetailPanel; normalize to a default.
    next.set("stage", normalizeLeadStage(contact.lead_stage));
  }
  return next;
};

export const getAccountsPersonFullPath = (
  contact: Pick<Contact, "id" | "status">,
) => getPersonShowPath(contact);
